import React, { createContext, useState, useContext } from 'react';
import axiosInstance from '../utils/axiosConfig';

// Create a context for authentication
const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  // Token is now stored in HttpOnly cookie, so we don't store it in state
  // We keep a flag to track authentication status
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const login = async () => {
    // Token is set by server in HttpOnly cookie
    // Just update the authentication status
    setIsAuthenticated(true);
  };

  const logout = async () => {
    try {
      // Call logout endpoint to clear the cookie on server
      await axiosInstance.post('/auth/logout');
    } catch (error) {
      console.error('Error during logout:', error);
    } finally {
      setIsAuthenticated(false);
      // Clear any localStorage data
      localStorage.removeItem('userInfo');
      localStorage.removeItem('isAuthenticated');
    }
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, setIsAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};
